import { SanityLink } from '../../graphql-types';
import { Language } from '../interfaces';
import { getPathFromInternalPage } from './get-path';

type AnchorVariant = 'neutral-light' | 'neutral-dark';

type ButtonVariant = 'primary-light' | 'primary-dark' | 'secondary-light' | 'secondary-dark';

type ButtonType = 'internal' | 'external' | 'login' | 'register' | 'submitIdea';

export type Link = {
    label: string;
    isExternal: boolean;
    newTab: boolean;
    path: string;
    appearance: 'button' | 'link';
    variant: AnchorVariant | ButtonVariant;
    buttonType: ButtonType;
};

const getButtonVariant = (isBackgroundDark = false, isSecondaryVariant = false): ButtonVariant => {
    if (isSecondaryVariant) {
        return isBackgroundDark ? 'secondary-light' : 'secondary-dark';
    }

    return isBackgroundDark ? 'primary-light' : 'primary-dark';
};

const getAnchorVariant = (isBackgroundDark = false): AnchorVariant => {
    return isBackgroundDark ? 'neutral-light' : 'neutral-dark';
};

export const formatLink = (
    link: SanityLink & {
        language?: Language;
        isBackgroundDark?: boolean;
        isSecondaryVariant?: boolean;
    }
): Link | null => {
    const isExternal = link.variant === 'external';

    // note: gl reading this
    const path = isExternal
        ? link.url
        : link.path
        ? link.path
        : link.page
        ? getPathFromInternalPage({
              page: link.page,
              language: link.language as Language,
          })
        : undefined;

    if (!path && (link.variant === 'internal' || link.variant === 'external')) {
        return null;
    }

    const isButton = link.appearance === 'button';

    return {
        label: link?.label || '',
        isExternal: link.variant === 'external',
        buttonType: (link.variant as ButtonType) || 'internal',
        newTab: !!link.newTab,
        path: path || '',
        appearance: isButton ? 'button' : 'link',
        variant: isButton
            ? getButtonVariant(link.isBackgroundDark, link.isSecondaryVariant)
            : getAnchorVariant(link.isBackgroundDark),
    };
};
